import type { ReactNode } from "react";
import type { UiActionName } from "@/core/telemetry/telemetryEvents";
import { userAction as userActionAttributes } from "@/core/telemetry/userAction";
import { Button } from "../shadcn/Button";
import { cn } from "@/shared/utils/cn";

interface ActionTileProps {
  title: string;
  icon: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  tone?: "matcha" | "ai" | "cream" | "neutral";
  className?: string;
  userAction?: UiActionName;
}

export function ActionTile({ title, icon, onClick, disabled, tone = "neutral", className, userAction }: ActionTileProps) {
  return (
    <Button
      variant="secondary"
      onClick={onClick}
      disabled={disabled}
      {...(userAction && userActionAttributes(userAction))}
      className={cn(
        "h-auto min-h-12 min-w-11 gap-1.5 rounded-2xl px-2 py-3",
        tone === "matcha" && "bg-matcha text-primary hover:bg-matcha/80",
        tone === "ai" && "bg-lilac text-lilac-foreground hover:bg-lilac/80",
        tone === "cream" && "bg-cream text-foreground hover:bg-cream/80",
        tone === "neutral" && "bg-muted text-foreground hover:bg-muted/80",
        className,
      )}
    >
      <span aria-hidden="true" className="flex shrink-0 items-center justify-center">{icon}</span>
      <span className="text-center text-sm">{title}</span>
    </Button>
  );
}
